import React from "react";
import { Box } from "@mui/material";

const KneePage = () => {
  return (
    <Box
      sx={{
        padding: 10,
      }}
    >
      {"WIP: Knee"}
    </Box>
  );
};

export default KneePage;
